"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductVariantsInnerImagesInnerToJSON = exports.ProductVariantsInnerImagesInnerFromJSONTyped = exports.ProductVariantsInnerImagesInnerFromJSON = exports.instanceOfProductVariantsInnerImagesInner = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ProductVariantsInnerImagesInner interface.
 */
function instanceOfProductVariantsInnerImagesInner(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfProductVariantsInnerImagesInner = instanceOfProductVariantsInnerImagesInner;
function ProductVariantsInnerImagesInnerFromJSON(json) {
    return ProductVariantsInnerImagesInnerFromJSONTyped(json, false);
}
exports.ProductVariantsInnerImagesInnerFromJSON = ProductVariantsInnerImagesInnerFromJSON;
function ProductVariantsInnerImagesInnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'altText': !(0, runtime_1.exists)(json, 'altText') ? undefined : json['altText'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
    };
}
exports.ProductVariantsInnerImagesInnerFromJSONTyped = ProductVariantsInnerImagesInnerFromJSONTyped;
function ProductVariantsInnerImagesInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'altText': value.altText,
        'name': value.name,
        'url': value.url,
    };
}
exports.ProductVariantsInnerImagesInnerToJSON = ProductVariantsInnerImagesInnerToJSON;
